import { Link } from "react-router-dom";
import { articles, categories, faqs } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function Home() {
  const featuredArticles = articles.filter((a) => a.featured);
  const hotArticles = articles.filter((a) => a.hot);
  const latestArticles = articles.slice(0, 8);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "打屁股漫画精选合集 - 首页",
            description:
              "喜欢打屁股漫画？本站精选海量打屁股漫画内容，涵盖搞笑、萌系、剧情多种风格，持续更新最新资源。",
            url: "https://dda668.cn",
            isPartOf: {
              "@type": "WebSite",
              name: "打屁股漫画精选合集",
              url: "https://dda668.cn",
            },
          }),
        }}
      />

      <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20cozy%20anime%20style%20background%20with%20soft%20pastel%20colors%2C%20cute%20chibi%20manga%20elements%20scattered%2C%20books%20and%20comics%20floating%2C%20dreamy%20atmosphere%2C%20cream%20and%20peach%20tones%2C%20artistic%20illustration%20with%20gentle%20gradients%2C%20whimsical%20storybook%20aesthetic%2C%20no%20text%2C%20soft%20focus%20background&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
            alt="打屁股漫画精选合集背景"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>
        </div>

        <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h1 className="font-heading text-3xl md:text-5xl text-white mb-4 leading-tight">
            打屁股漫画精选合集
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            精选海量打屁股漫画内容，涵盖搞笑、萌系、剧情多种风格，
            持续更新最新资源，带你发现最有趣的打屁股漫画世界！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap text-sm"
            >
              浏览全部漫画
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white font-medium rounded-full hover:bg-white/30 transition-colors whitespace-nowrap text-sm border border-white/30"
            >
              了解更多
            </Link>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-6">
        <div className="w-full max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              漫画分类
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              按你的喜好选择漫画类型，总有一款适合你
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            {categories
              .filter((c) => c.slug !== "all")
              .map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center gap-3 p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300"
                >
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-50 group-hover:bg-primary-100 transition-colors">
                    <i className={`${cat.icon} text-2xl text-primary-500`}></i>
                  </span>
                  <span className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-400 text-center leading-relaxed">
                    {cat.description}
                  </span>
                </Link>
              ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-1">
                精选推荐
              </h2>
              <p className="text-sm text-foreground-500">
                编辑精选的最优质漫画内容
              </p>
            </div>
            <Link
              to="/category/all"
              className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              查看全部
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {featuredArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-6">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-1">
                热门排行
              </h2>
              <p className="text-sm text-foreground-500">
                大家最爱看的漫画都在这里
              </p>
            </div>
            <Link
              to="/category/all"
              className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              查看全部
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {hotArticles.map((article, index) => (
              <div key={article.id} className="relative">
                {index < 4 && (
                  <span className="absolute top-3 left-3 z-10 w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                    {index + 1}
                  </span>
                )}
                <ArticleCard article={article} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="w-full max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              持续更新的漫画内容，不错过任何精彩
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {latestArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-6">
        <div className="w-full max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500">
              关于打屁股漫画精选合集
            </p>
          </div>
          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <details
                key={index}
                className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100/50 transition-colors list-none">
                  <span className="text-sm font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform">
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </>
  );
}